import { UseRoleProps } from "@floating-ui/react";

import { TooltipRole } from "./types";

export const getTooltipRole = (role: TooltipRole): UseRoleProps["role"] => {
  switch (role) {
    case "label":
      return "label";
    case "additional-info":
    case "description":
      return "tooltip";
  }
};
